import React, { useContext } from 'react';

import { Route, Redirect, useLocation } from 'react-router-dom';

import { RXDContext } from '../../context/RXDContext';
import { LearnerInfo } from '../../types';
import Cookies from '../../utils/cookies';
import { useAuth } from '../../utils/hooks';

interface Props {
  path: string;
  exact: boolean;
  render: Function;
  userInfo?: LearnerInfo;
  userLoading: boolean;
}

const ProtectedRXDRoute: React.FC<Props> = ({
  path,
  exact = false,
  render,
  userInfo,
  userLoading,
}) => {
  const lms_token = Cookies.get('lms_token');
  const { rxdUserInfo } = useContext(RXDContext);
  const location = useLocation();
  const { isInitialized, isLoading } = useAuth();

  //check to determine the correct redirect if there is no access
  if (userLoading || !isInitialized || isLoading) {
    return null;
  } else if (!(!userLoading && userInfo?.has_subscription) && (!lms_token || !rxdUserInfo?.id)) {
    if (window?.frameElement) {
      return <Redirect to="/rxd/landing" />;
    } else if (!userInfo) {
      return <Redirect to={{ pathname: '/login', state: { prevPath: location.pathname } }} />;
    } else if (!userInfo?.has_subscription) {
      return <Redirect to="/pricing" />;
    }
  }

  return (
    <Route path={path} exact={exact}>
      {render()}
    </Route>
  );
};

export default ProtectedRXDRoute;
